import { BannerAdsSection } from '~types/index'

import { GPTContainer, GPTSlot } from './GPT'

const BannerAdsSectionComponent = ({
  id,
  path,
  size,
  skeleton,
  targeting,
  aspectRatio,
  adsPerRow = 0,
}: BannerAdsSection) => {
  return (
    <GPTContainer fallback={skeleton}>
      {Array.from({ length: adsPerRow }).map((ad, index) => (
        <GPTSlot
          id={`${id}-${index + 1}`}
          key={`${id}-${index + 1}`}
          selector={id}
          adUnitPath={path}
          slotSize={size}
          fallback={skeleton}
          aspectRatio={aspectRatio}
          targeting={targeting}
        />
      ))}
    </GPTContainer>
  )
}

export default BannerAdsSectionComponent
